<style lang="scss" scoped>
.export-box {
  display: flex;
  flex-direction: column;

  .export-item {
    padding: 10px;

    .export-desc {
      font-size: 14px;
      margin-top: 10px;

      span {
        margin-right: 5px;
      }

      font {
        color: red;
        padding: 0 5px;
      }
    }
  }
}

::deep .el-dialog__body {
  padding: 20px;
}
</style>
<template>
  <el-dialog title="数据导出" v-bind="$attrs" width="30%" v-on="$listeners">
    <div class="export-box">
      <div v-for="item in radioList" :key="item.label" class="export-item">
        <el-card>
          <el-radio v-model="selectRadio" :label="item.label">{{ item.title }}</el-radio>
          <div class="export-desc">
            <Download v-if="item.label === 1" theme="filled" size="14" fill="#9b9b9b" />
            <FolderDownload v-if="item.label === 2" theme="filled" size="14" fill="#9b9b9b" />
            <InboxIn v-if="item.label === 3" theme="filled" size="14" fill="#9b9b9b" />
            <span v-if="item.label === 1">确认导出所选择的 <font>{{ selectData.length }}</font>条数据</span>
            <span v-if="item.label === 2">确认导出所选择的<font>{{ pageData.length }}</font>条数据</span>
            <span v-if="item.label === 3">确认导出所选择的<font>{{ allData }}</font>条数据</span>
          </div>
        </el-card>
      </div>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button type="primary" @click="exportData()">确 定</el-button>
    </span>
  </el-dialog>
</template>
<script>
import { Download, FolderDownload, InboxIn } from '@icon-park/vue'
export default {
  name: 'ExportDialog',
  components: {
    Download,
    FolderDownload,
    InboxIn
  },
  props: {
    // 选择的数据项
    selectData: {
      type: Array,
      default: () => []
    },
    // 本页面的数据项
    pageData: {
      type: Array,
      default: () => []
    },
    // 全部的数据项
    allData: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      radioList: [
        { title: '所选数据', label: 1, count: 0 },
        { title: '本页数据', label: 2, count: 0 },
        { title: '全部数据', label: 3, count: 0 }
      ],
      selectRadio: 1
    }
  },
  methods: {
    // 导出确认按钮
    exportData() {
      let ids = []
      if (this.selectRadio === 1) {
        ids = Array.from(this.selectData, i => i.id)
      }
      if (this.selectRadio === 2) {
        ids = Array.from(this.pageData, i => i.id)
      }
      this.$emit('res-ids', ids)
    }
  }
}
</script>
